<template>
    <div class="d-flex align-items-center py-4 bg-body-tertiary">
        <main class="form-signin w-100 m-auto">
            <!-- <form class="text-center"> -->
                <!-- <img class="mb-4" src="../images/bootstrap-logo.svg" alt="" width="72" height="57" loading="lazy"> -->
                <h1 class="h3 mb-3 fw-normal">サインインして下さい</h1>

                <div class="form-floating">
                    <!-- <input type="email" class="form-control" id="floatingInput" placeholder="name@example.com"> -->
                    <input type="email" v-model="inputValueId" class="form-control" id="floatingInput"
                        placeholder="name@example.com">
                    <label for="floatingInput">Emailアドレス</label>
                </div>
                <div class="form-floating">
                    <!-- <input type="password" class="form-control" id="floatingPassword" placeholder="パスワード"> -->
                    <input type="password" v-model="inputValuePassword" class="form-control" id="floatingPassword"
                        placeholder="パスワード">
                    <label for="floatingPassword">パスワード</label>
                </div>
                <div class="message">
                    <p class="red">{{ errorMessage }}&nbsp;</p>
                    <p class="success">{{ message }}</p>
                </div>


                <!-- <button class="btn btn-primary w-100 py-2" type="submit">サインイン</button> -->
                <button class="btn btn-primary w-100 py-2" type="submit" v-on:click="logIn">ログインする</button>
                <br>
                <br>
                <RouterLink to="/">試合一覧に戻る</RouterLink>
            <!-- </form> -->
        </main>
    </div>
</template>
  
<script setup>
import { ref } from 'vue';
import { useRoute, useRouter } from 'vue-router'
import { signInWithEmailAndPassword } from "firebase/auth";
import Firebase from "../firebase-settings/index.js"
const auth = Firebase.auth
const router = useRouter()
var inputValueId = ref()
var inputValuePassword = ref()
var errorMessage = ref()
var message = ref()
var isLoading = ref()

const logIn = () => {
    // IDとパスワードの未入力チェック
    if (inputValueId === undefined || inputValueId === "" || inputValuePassword === undefined || inputValuePassword === "") {
        errorMessage = 'IDまたはパスワードが未入力です'
        return
    }

    // // エラーメッセージの消去
    errorMessage = ""

    // ローディングアニメーション
    isLoading = true

    // id,passを取得
    const mId = inputValueId.value
    const mPass = inputValuePassword.value

    // 連続クリックを防ぐためにパスワード欄を空欄にする
    inputValuePassword = ""

    // サインインメソッド
    signInWithEmailAndPassword(auth, mId, mPass)
        // サインイン成功時
        .then((userCredential) => {
            const user = userCredential.user;
            user.getIdTokenResult()
            .then((idTokenResult) => { console.log(idTokenResult.claims.role)})
            //router.push({name: 'menu'})
            message = "ログインに成功しました"
            router.push('/ops/menu')
        })


        // サインイン失敗時
        .catch((error) => {
            console.log(error)
            const errorCode = error.code;
            const errorMessage = error.message;
            console.log('ログインエラー: errorCode -> ' + errorCode + ', errorMessage -> ' + errorMessage)
            JudgeErrorCode(errorCode)

            // ローディングアニメーション
            isLoading = false
            // router.push({ path: '/login'})
        });
};

const JudgeErrorCode = (mError) => {
    const errorCode = String(mError)
    if (errorCode === 'auth/wrong-password' || errorCode === 'auth/invalid-value-(email)' || errorCode === 'auth/user-not-found') {
        errorMessage = "ログインに失敗しました。IDまたはパスワードが間違っています"
    } else {
        errorMessage = "ログインに失敗しました。予期せぬエラーが発生しました。"
    }
};
</script>

<style scoped>
.form-signin {
    max-width: 330px;
    padding: 1rem;
}

.form-signin .form-floating:focus-within {
    z-index: 2;
}

.form-signin input[type="email"] {
    margin-bottom: -1px;
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
}

.form-signin input[type="password"] {
    margin-bottom: 10px;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
}
</style>
  